import React, { useState, useEffect } from 'react';
import { Navbar, Container, Form, Button, InputGroup, Nav } from 'react-bootstrap';
import logo from '../../media/brey_digital.png'
import * as FaIcons from 'react-icons/fa6'
import { TbLayoutSidebarLeftExpand, TbLayoutSidebarLeftCollapse } from "react-icons/tb";
import { Link } from 'react-router-dom';

const Header = ({ toggleSidebar, isMobile, isOpen, pagetitle }) => {
  const userRole = localStorage.getItem('userRole');
  const userCompany = localStorage.getItem('userCompany');
  const userName = localStorage.getItem('userName');

  const [searchQuery, setSearchQuery] = useState('');
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    console.log('Searching for:', searchQuery);
    // Implement search functionality
  };

  const toggleMobileSearch = () => {
    setIsMobileSearchOpen(!isMobileSearchOpen);
  };

  return (
    <Navbar 
      bg="white" 
      variant="light" 
      // fixed="top" 
      className={`sticky ${scrolled ? 'shadow' : ''}`}
      style={{
        height: '52px',
        borderBottom: '1px solid #e3e3e3',
      }}
    >
      <Container fluid className="px-0 px-md-2">
        <div className="d-flex align-items-center">
          {isMobile && (
            <div className="py-2">
              <button 
                  className="d-flex align-items-center py-2 rounded w-100 text-gray-600 focus:outline-none" 
                  onClick={toggleSidebar}
              >
                <div className='me-3'>
                    <TbLayoutSidebarLeftExpand size={24} />
                    {/* <MdIcons.MdLogout /> */}
                </div>
              </button>
            </div>
          )}

          {/* <Navbar.Brand href="/" className="flex items-center me-4" style={{ color: '#FF8000' }}>
            <span className='text-gray-500 font-semibold'>Brey
            </span>
            ERP
            <span className='text-sm text-gray-700 ml-1'>| {userCompany}</span>
          </Navbar.Brand> */}
          {isOpen || isMobile ? (
          <Link to="/" className="inline" style={{ color: '#FF8000' }}>
            <span className='text-gray-500 font-semibold'>Brey
            </span>
            ERP
          </Link>        
          ) : ''
          }
          {/* <h1 className="text-2xl font-bold">{pagetitle}</h1> */}
        </div>

        {/* Center section - Search - hide on mobile unless toggled */}
        {/* <div 
          className={`${isMobileSearchOpen ? 'd-flex' : 'd-none'} d-md-flex position-relative align-items-center`}
          style={isMobileSearchOpen ? { 
            position: 'absolute', 
            left: 0, 
            right: 0, 
            top: 0, 
            backgroundColor: 'white', 
            height: '56px', 
            zIndex: 10,
            padding: '0 16px'
          } : { flex: 1, maxWidth: '600px', margin: '0 auto' }}
        >
          {isMobileSearchOpen && (
            <Button 
              variant="link" 
              className="p-1 me-2 text-dark d-md-none" 
              onClick={toggleMobileSearch}
            >
              <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
            </Button>
          )}
          
          <Form className="d-flex flex-grow-1" onSubmit={handleSearchSubmit}>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearchChange}
                style={{ borderRadius: '40px 0 0 40px' }}
              />
              <Button 
                variant="light" 
                type="submit"
                style={{ 
                  borderRadius: '0 40px 40px 0', 
                  borderLeft: 'none',
                  backgroundColor: '#f8f9fa',
                  borderColor: '#ced4da'
                }}
              >
                <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </Button>
            </InputGroup>
          </Form>
        </div> */}

        {/* Right section - Icons */}
        <Nav className="ms-auto d-flex align-items-center">
          {/* Mobile search toggle */}
          {/* {!isMobileSearchOpen && (
            <Button 
              variant="link" 
              className="p-1 text-dark d-md-none" 
              onClick={toggleMobileSearch}
              aria-label="Search"
            >
              <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </Button>
          )} */}

          {/* Create video button */}
          {/* <Button 
            variant="link" 
            className="p-1 mx-2 text-dark d-none d-sm-block"
          >
            <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
            </svg>
          </Button> */}

          {/* Notifications */}
          <Button 
            variant="link" 
            // className="p-1 mx-2 text-dark d-none d-sm-block"
            className="p-1 mx-2 text-dark d-block"
          >
            <FaIcons.FaRegBell/>
          </Button>

          {/* Avatar/Profile */}
          <Link to="/profile">
          <div className=" flex items-center justify-center text-gray-600 text-sm font-semibold border border-blue-600 px-2 py-1 rounded shadow-sm">
            {["super_admin", "admin_user"].includes(userRole) && (
            <FaIcons.FaUserShield size={18} className='mr-1 text-green-600'/>
            )}
            {["process_user", "item_user"].includes(userRole) && (
            <FaIcons.FaUser size={14} className='mr-1 text-orange-600'/>
            )}
            {userCompany}
          </div>
          </Link>
          {/* {userRole === "item_user" ?
          <div className=" flex items-center justify-center text-gray-600 text-sm font-semibold border border-blue-600 px-2 py-1 rounded shadow-sm">
            <FaIcons.FaUser size={14} className='mr-1 text-orange-600'/>
            {userCompany}
          </div>
          : "" } */}

        </Nav>
      </Container>
    </Navbar>
  );
};

export default Header;